import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';

export default component$(
  ({ cssClasses }: { cssClasses: string }): JSX.Element => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        class={cssClasses}
        viewBox='0 0 40 40'
      >
        <g fill-rule='evenodd'>
          <path
            d='M18.75 0L8.125 10.709 9.658 12.247 17.655 4.229 17.655 31.25 19.846 31.25 19.846 4.229 27.841 12.247 29.375 10.709 18.751 0z'
            transform='translate(1.25)'
          />
          <path
            d='M35.357 20L35.357 37.778 2.143 37.778 2.143 20 0 20 0 40 37.5 40 37.5 20z'
            transform='translate(1.25)'
          />
        </g>
      </svg>
    );
  }
);
